<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div ref="totalRef" class="subpage">
    <template v-if="$route.path === '/plum'">
      <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="梅花易数" :is-sub-page="true">
        <!--
        <template v-slot:rightBtn v-show="showShare">
          <span class="btn btn-share" @click="shareClick"></span>
        </template>
        -->
      </Header>

      <div ref="contentRef" class="forecast-list">
        <div style="padding-bottom: 78%; height: 0">
          <img src="@/assets/images/backgrounds/bg-mhyc.png" alt="pic" class="bg-img"/>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 20px;">
          <div class="item" @click="reportForecast" style="margin-right: 50px;">
            <img src="@/assets/images/icons/icon-mh-bs.png" />
            <div>报数起卦</div>
          </div>
          <div class="item" @click="randomForecast">
            <img src="@/assets/images/icons/icon-mh-sj.png" />
            <div>随机起卦</div>
          </div>
        </div>
      </div>
    </template>

    <router-view />
  </div>
</template>

<script>
import Header from '@/components/Header'
// import { shareTest } from '@/api/test'

export default {
  name: 'Forecast',
  components: {
    Header
  },
  data () {
    return {
      showShare: true,
      needP: true
    }
  },
  watch: {
    $route (to, from) {
      if (to.name === 'forecast') {
        document.title = '梅花易数'
      }
    }
  },
  mounted () {
    document.title = '梅花易数'

    let isNeedPermission = this.$route.query.permission
    if (isNeedPermission !== undefined && isNeedPermission === 0) {
      this.showShare = false
      this.needP = false
    }
  },
  methods: {
    randomForecast () {
      this.$store.commit('setForecast', '随机起卦')
      let tmp1 = 0
      while (tmp1 === 0) {
        tmp1 = Math.round(Math.random() * 10)
      }
      let tmp2 = 0
      while (tmp2 === 0) {
        tmp2 = Math.round(Math.random() * 10)
      }

      this.$store.commit('setForecastNum', { num1: tmp1, num2: tmp2 })
      this.gotoPage('/plum/randomresult', '随机起卦')
    },
    reportForecast () {
      this.$store.commit('setForecast', '报数起卦')
      this.gotoPage('/plum/report', '报数起卦')
    },
    gotoPage (url, title) {
      this.$router.push({
        path: url,
        query: {
          platform: this.$route.query.platform,
          title: title
        }
      })
    },
    shareClick () {
      console.log('梅花 share')
      var json = {
        typeCode: '2'
      }
      if (this.testId) {
        json['testId'] = this.testId
      }
      // 判断权限
      this.$dfzhJsBridge.share({
        url: process.env.VUE_APP_SHARE_URL + '/plum?permission=0',
        title: '东方智汇梅花易数',
        description: ' '
      })

      // shareTest(json).then((res)=>{
      //   this.$dfzhJsBridge.share(JSON.stringify(res.data))
      // }).catch((err)=>{
      //   //test share
      //
      // })
    }
  }
}
</script>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
  .forecast-list
    display flex
    flex-direction column
    width 100%
    height 100%
  .item
    display flex
    flex-direction column
    justify-content center
    align-items center
    justify-items center
    background #ffffff
    width 110px
    height 110px
    border-radius 8px
    border 1px solid #874DD5
    box-shadow 0 3px 6px 0 rgba(97, 97, 97, 0.3)
    img
      width 45px
      height 45px
      margin-bottom 12px
    div
      font-size 14px
      color #874DD5
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
